import React, { useEffect, useState } from "react";
import "@Styles/mandate.css";
import { connect } from "react-redux";
import { getUserToken, fetchAllTickets } from "../../../Redux/RaiseTicket/action";
import arrowleft from "@Images/NewUI/Vector.png";
import greaterthen from "../../../Images/NewUI/greaterthen.png";
import { Loader } from "../Common/Loader";
import moment from "moment";
import { HEADING_TICKETHISTORY} from "../Common/constant";


const CheckTicketHistory = (props) => {
  const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  const [obj, setObj] = useState({
    id: "one",
    message: "successful",
  });
  const [state, setState] = useState({
    data: [],
    updateUserToken: {},
    tickets: "",
    ticketData: "",
    reset_password: false,
    loading: false,
  });
  const [loader, setLoader] = useState(false);

  
 
  useEffect(() => {
    setState({ loading: true });

    let ticketArray = [],
      ticketQueue = [];
    let data = { reset_password: false };
    setLoader(true);
    props
      .getUserToken({ data, token })
      .then((res) => {
        setState({ updateUserToken: res.data }, () => {});
        let fetchData = {
          token: res?.data?.password,
          email: res?.data?.email,
        };

        props
          .fetchAllTickets({ fetchData, token })
          .then((res) => {
            setState({ loading: false });
            setState({ tickets: res.data.assets.Ticket });

            for (var key in res.data.assets.Ticket) {
              if (res.data.assets.Ticket.hasOwnProperty(key)) {
                var obj = res.data.assets.Ticket[key];
                ticketArray.push(obj);
              }
            }
            for (var i = ticketArray.length - 1; i >= 0; i--) {
              ticketQueue.push(ticketArray[i]);
            }

            setState({ ticketData: ticketQueue });
            setLoader(false);
          })
          .catch((err) => {
            setLoader(false);
            // fetchTicket();
            // console.log(err);
          });
      })
      .catch((err) => {
        setLoader(false);
        getToken();
        // console.log(err);
      });
  }, []);
  let { ticketData } = state;

  return (
    <div id="background" className="main_div  ">
      {loader ? (
        <Loader />
      ) : (
        <>
          <br />
          
      <div className="toolbarRespo">
      <div className="shadowlinepurenew maxWidth450">
      <img style={{cursor:"pointer"}} className="arrowimgonseeticket ml-28" src={arrowleft} onClick={() => {
          window.location.href="/raise_ticket";
      }} /> 
       <h1 className="boldheading" style={{ marginBottom:40, paddingLeft:"100px", color:'#152745', fontWeight:'800', fontSize:'25px'}}>{HEADING_TICKETHISTORY}</h1>
       </div>
       </div>
          <div className="container">

            <div className="pb-4">
              {/* {console.log("ticketData", ticketData?.length)} */}
              {ticketData &&
                ticketData.map((el, index) => {
                  // console.log("el", el, index);
          
                  
                  return (
                    <div className="history_list">
                      <div className="hist_list_wrapper ticketHistborder" style={{borderRadius: 5, paddingBottom: "25px"}}>
                      {/* <span className="tickethistoryarrow">~</span> */}
                      <img style={{cursor:"pointer", width:4, height:8,}} className="arrowtransform" src={greaterthen} /> 
                        <div className="flex space-between align-center">
                        
                          <a href={`/seeTicketHistory?id=${el?.id}&state_id=${el?.state_id}&title=${el?.title}`}>
                          <p style={{color:"#152745", fontWeight:500, fontSize:14}}>{el?.title || obj?.message} </p>
                          </a>
                          {el?.state_id === 1 || el?.state_id === 3 ? (
                            <span className="pending">Pending</span>
                          ) : (
                            <span className="success">Closed</span>
                          )}
                        </div>
                        <p>
                          <span className="h_day">
                            {moment(el.created_at).format("ddd")},
                          </span>
                          <span className="h_date">
                            {moment(el.created_at).format("D MMM YYYY h:mm a")}
                          </span>
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          {/* {state.ticketData  ? null : (
            <LoanHistoryNoData
              text="Ticket history not found."
              PageText="Ticket History"
              history={props.history}
            />
          )} */}
        </>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
    document_status: state.userDetail,
  };
};

export default connect(mapStateToProps, {
  getUserToken,
  fetchAllTickets,
})(CheckTicketHistory);
